module.exports = __webpack_public_path__ + "y.png?048f2e8e6e9da1d6db07177122fca792";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/y.png
// module id = 80
// module chunks = 0